var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGym(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.73459 13.7323C7.73459 13.7323 8.64005 12.5102 9.23459 12.2319C11.0294 11.3915 11.3945 11.0263 12.2346 9.23091C12.5129 8.63618 13.7346 7.73044 13.7346 7.73044M10.2346 16.2331C10.2346 16.2331 11.4563 15.3273 11.7346 14.7326C12.5747 12.9373 12.9398 12.5721 14.7346 11.7317C15.3291 11.4533 16.2346 10.2312 16.2346 10.2312M17.9379 3.45254C19.8203 0.985467 23.1402 3.8401 20.5433 6.02872M3.37832 17.9773C0.99868 19.9687 3.99803 23.1586 6.06763 20.4657M14.4313 2.89207C14.9382 2.38343 15.7613 2.38212 16.2698 2.88916L21.0816 7.68726C21.5901 8.1943 21.5914 9.01767 21.0845 9.52632L19.5559 11.0603C19.049 11.5689 18.2259 11.5702 17.7174 11.0632L12.9056 6.26507C12.3972 5.75803 12.3959 4.93466 12.9027 4.42601L14.4313 2.89207ZM4.41398 12.9022C4.92086 12.3936 5.74397 12.3923 6.25246 12.8993L11.0643 17.6974C11.5727 18.2045 11.574 19.0278 11.0672 19.5365L9.53857 21.0704C9.03169 21.5791 8.20858 21.5804 7.70009 21.0733L2.88829 16.2752C2.3798 15.7682 2.3785 14.9448 2.88538 14.4362L4.41398 12.9022Z",
    stroke: "#525252",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGym);
export default __webpack_public_path__ + "static/media/gym.65e505ac1858311f9683794b48b165dc.svg";
export { ForwardRef as ReactComponent };